import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';

const DEFAULT_OBJECT = {};
const DEFAULT_ARRAY = [];

const getFilesStore = (state) => state?.filesReducer || DEFAULT_OBJECT;
const getFileIdProp = (state, props) => props?.fileId;

const getFileByIdSelector = createSelector(
  [getFilesStore, getFileIdProp],
  (store, fileId) => {
    const result = store?.[fileId] || {};
    return isEmpty(result) ? DEFAULT_OBJECT : result;
  }
);

const getSignedUrlSelector = createSelector(
  getFileByIdSelector,
  (file) => file?.signedUrl
);

export const makeGetSignedUrlSelector = () => getSignedUrlSelector;
